export default "__VITE_ASSET__Dj5kJ4UW__"